import {
  getPerformanceEmoji,
  getPerformanceText,
} from "@/modules/performance/utils";

export const ScoreItem = ({ label, score }) => (
  <div className="flex items-start gap-3">
    <div>
      <div className=" text-lg text-muted-foreground">{label}</div>
      <div className=" flex items-center gap-2">
        {getPerformanceEmoji(score) && (
          <span>{getPerformanceEmoji(score)}</span>
        )}
        <span>{getPerformanceText(score)}</span>
      </div>
    </div>
  </div>
);
